import {extendTheme} from '@salesforce/retail-react-app/app/components/shared/ui'
import {overrides as base} from '@salesforce/retail-react-app/app/theme'

import styles from './foundations/styles'
import fonts from './foundations/fonts'
import sizes from './foundations/sizes'
import layerStyles from './foundations/layerStyles'
import textStyles from './foundations/textStyles'
import breakpoints from './foundations/breakpoints'

import InfiniteScrollStyles from './components/project/infinite-scroll'
import ProductListStyles from './components/project/product-list'
import ProductViewCompactStyles from './components/project/product-view-compact'
import CartStyles from './components/project/cart'
import LoginSignUpForm from './components/project/login-signup-form'
import CheckoutBagItem from './components/project/checkout-bag-item'
import ProductTileStyles from './components/project/product-tile'
import SuggestionsStyle from './components/project/suggestions'
import WishlistStyles from './components/project/wishlist'
import Breadcrumb from './components/project/breadcrumb'
import Link from './components/base/link'
import FormStyles from './components/project/form'
import LoginStyles from './components/project/login'
import ProductView from './components/project/product-view'
import ProductViewModalStyles from './components/project/product-view-modal'
import OptiversalLinks from './components/project/optiversal-links'
import GiftCertificate from './components/project/gift-certificate'
import ImageGallery from './components/project/image-gallery'
import Form from './components/base/form'
import ProductDetailsAccordion from './components/project/product-details-accordion'
import ProductRating from './components/project/product-rating'
import ProductPromotionCallouts from './components/project/product-promotion-callouts'
import Progress from './components/base/progress'
import Stepper from './components/base/stepper'
import XxValueBadge from './components/base/xx-value-badge'
import TextTilesX4 from './components/project/text-tiles-x4'
import Bmsm from './components/project/bmsm'
import Gwp from './components/project/gwp'
import HeroPromotions from './components/project/hero-promotions'
import HeroXxValueBadge from './components/project/hero-xx-value-badge'
import HeroCustomTextBanner from './components/project/hero-custom-text-banner'
import AddToCartDrawerStyles from './components/project/add-to-cart-drawer'
import OrderSummaryStyles from './components/project/order-summary'
import CouponCodeStyles from './components/project/coupon-code'
import BirthdayPromoCard from './components/project/birthday-promo-card'
import IdmeStyles from './components/project/idme'
import PwpCarouselStyles from './components/project/pwp-carousel'
import LoqateStyles from './components/loqate'
import CheckoutStyles from './components/project/checkout'
import CharitableDonation from './components/project/charitable-donation'
import GiftWrapBox from './components/project/gift-wrap'
import NavAssetCard from './components/project/nav-asset-card'
import RedeemGiftCard from './components/project/redeem-giftcard'
import DollyMessage from './components/project/dolly-message'
import OrderConfirmation from './components/project/order-confirmation'
import CheckoutProgress from './components/project/checkout-progress'
import CheckoutFooter from './components/project/checkout-footer'
import ValidateAddressModal from './components/project/validate-address-modal'
export const overrides = {
    ...base,
    fonts,
    sizes,
    layerStyles,
    textStyles,
    breakpoints,

    components: {
        ...base.components,
        InfiniteScrollStyles,
        ProductTileStyles,
        ProductListStyles,
        AddToCartDrawerStyles,
        WishlistStyles,
        ProductViewCompactStyles,
        CartStyles,
        LoginSignUpForm,
        CheckoutBagItem,
        CheckoutStyles,
        RedeemGiftCard,
        SuggestionsStyle,
        ImageGallery,
        FormStyles,
        LoginStyles,
        Breadcrumb,
        Link,
        ProductView,
        ProductViewModalStyles,
        OptiversalLinks,
        GiftCertificate,
        CheckoutFooter,
        Form,
        ProductDetailsAccordion,
        ProductRating,
        ProductPromotionCallouts,
        Progress,
        Stepper,
        XxValueBadge,
        TextTilesX4,
        Bmsm,
        Gwp,
        HeroPromotions,
        HeroXxValueBadge,
        HeroCustomTextBanner,
        OrderSummaryStyles,
        CouponCodeStyles,
        IdmeStyles,
        BirthdayPromoCard,
        PwpCarouselStyles,
        LoqateStyles,
        CharitableDonation,
        GiftWrapBox,
        NavAssetCard,
        DollyMessage,
        OrderConfirmation,
        CheckoutProgress,
        ValidateAddressModal
    },

    styles: {
        global: styles
    }
}

export default extendTheme(overrides)
